module.exports = __webpack_public_path__ + "static/media/no-influencers.6aee6e34.png";